/**
 * Comunicaciones API
 * Comunicaciones API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmpresasAsociadasUsuarioDTO { 
    id?: number;
    tipoUsuario?: EmpresasAsociadasUsuarioDTO.TipoUsuarioEnum;
    razonSocial?: string;
    centroPoseedor?: string;
}
export namespace EmpresasAsociadasUsuarioDTO {
    export type TipoUsuarioEnum = 'ADMINISTRACION' | 'ADHERIDO' | 'POSEEDOR' | 'GESTOR_ENVALORA' | 'GESTOR_POSEEDOR' | 'PUNTO_RECOGIDA' | 'GESTOR_PUNTO_RECOGIDA' | 'COMUNICACION' | 'ACUERDOS_GESTORES' | 'USUARIO';
    export const TipoUsuarioEnum = {
        Administracion: 'ADMINISTRACION' as TipoUsuarioEnum,
        Adherido: 'ADHERIDO' as TipoUsuarioEnum,
        Poseedor: 'POSEEDOR' as TipoUsuarioEnum,
        GestorEnvalora: 'GESTOR_ENVALORA' as TipoUsuarioEnum,
        GestorPoseedor: 'GESTOR_POSEEDOR' as TipoUsuarioEnum,
        PuntoRecogida: 'PUNTO_RECOGIDA' as TipoUsuarioEnum,
        GestorPuntoRecogida: 'GESTOR_PUNTO_RECOGIDA' as TipoUsuarioEnum,
        Comunicacion: 'COMUNICACION' as TipoUsuarioEnum,
        AcuerdosGestores: 'ACUERDOS_GESTORES' as TipoUsuarioEnum,
        Usuario: 'USUARIO' as TipoUsuarioEnum
    };
}


